import { GET_ALL_NOTIFICATIONS } from "../notifications/notifications-query";
import { MARK_ALL_NOTIFICATION_AS_READ } from "./notification-read.mutation";
import { MarkNotificationReadAll } from "./notification-read.interface";
import { useMutation } from "@apollo/client";

export const useReadAllNotification = () => {
  const [markAllNotificationAsRead] = useMutation<MarkNotificationReadAll>(MARK_ALL_NOTIFICATION_AS_READ);

  const readAllNotification = () => {
    markAllNotificationAsRead({
      refetchQueries: [GET_ALL_NOTIFICATIONS],
    });
  };

  return {
    readAllNotification,
  };
};
